export { AudioModule } from './lib/audio.module';
export { WaveConfigOptions} from './lib/models/waveconfig.model';
